
import {Component, Prop, Vue} from 'vue-property-decorator';
@Component
export default class ModalFinanceOperations extends Vue {
    @Prop() readonly form!: any;

}
